export default __webpack_public_path__ + "static/media/hidraulic22.505ac25b.jpeg";